<!--
File Name          : projectile.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="lesson-component-container">

    @if(scalars.includes(ProjectileFields.FLIGHT_TIME)){<div class="scalar-datum">
        <div class="datum-title">Flight Time</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.flightTime_s)}} s</div>
    </div>}
    @if(scalars.includes(ProjectileFields.HORIZONTAL_DISPLACEMENT)){<div class="scalar-datum">
        <div class="datum-title">Horizontal Displacement</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.displacement_m)}} m</div>
    </div>}
    @if(scalars.includes(ProjectileFields.LAUNCH_VELOCITY)){<div class="scalar-datum">
        <div class="datum-title">Launch Velocity</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.launchVel_mps)}} m/s</div>
    </div>}
    @if(scalars.includes(ProjectileFields.MAX_HEIGHT)){<div class="scalar-datum">
        <div class="datum-title">Max Height</div>
        <div class="datum-value">{{localVariableSigFigsFormatter(results?.max_hgt)}} m</div>
    </div>}

    @if(screenservice.isMobile) {
        <div class="chart-container mobile-chart-options">
            <div style="text-align: center; margin-bottom: 8px;">Select to Graph</div>
            <div class="chart-controls">
                <dx-button 
                    *ngFor="let series of availableDataSeries"
                    [text]="series.text"
                    icon="datatrending"
                    [disabled]="false"
                    
                    stylingMode="contained"
                    type="default"
                    (onClick)="openMobileChart(series.valueField)"
                ></dx-button>
            </div>
        </div>
    } 
    @else {
        <div class="chart-container">
            <div class="chart-controls">
                <div>Select to Graph</div>
                <dx-button-group
                    [items]="availableDataSeries"
                    [(selectedItemKeys)]="selectedDataSeries"
                    selectionMode="single"
                    stylingMode="outlined"
                    keyExpr="valueField"
                    ></dx-button-group>
            </div>
            <dx-chart
                [dataSource]="getFilteredData()"
                style="height: calc(100% - 36px)"
            >
            <dxo-zoom-and-pan
                argumentAxis="both"
                valueAxis="none"> <!-- or "zoom" | "pan" | "none" -->
            </dxo-zoom-and-pan>
            <dxo-tooltip
                    [enabled]="true"
                    [customizeTooltip]="customizeTooltip"
            ></dxo-tooltip>
            <dxo-size
                [height]="360">
            </dxo-size>
                <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
                <dxo-legend [visible]="false"></dxo-legend>
                <dxo-common-series-settings
                    #seriesSettings
                    argumentField="time_s"
                    type="spline"
                >
                    <dxo-point [visible]="false"></dxo-point>
                </dxo-common-series-settings>
                <dxo-common-axis-settings [valueMarginsEnabled]="true">
                    <dxo-label>
                        <dxo-font size="18"></dxo-font>
                    </dxo-label>
                </dxo-common-axis-settings>
                <dxi-series *ngIf="isSeriesSelected('velocityX')" color="#424242" valueField="velocityX" axis="vel_x_axis"></dxi-series>
                <dxi-series *ngIf="isSeriesSelected('velocityZ')" color="#424242" valueField="velocityZ" axis="vel_z_axis"></dxi-series>
                <dxi-series *ngIf="isSeriesSelected('height')" color="#424242" valueField="hgt_m" axis="pos_axis"></dxi-series>
                <!-- 19821: the value axes below used to hard-floor wholeRange at startValue: -1.
                     Velocity X/height never approach -1 so it was invisible for them, but Velocity Y
                     legitimately falls well past -1 m/s, so every point past that floor was clipped -
                     the line just stopped mid-flight while X/Height kept going. Let each axis auto-range
                     off the real data (minValueMargin/maxValueMargin already pad it) instead. -->
                <dxo-argument-axis [wholeRange]="{ endValue: getAxisMaxTime(selectedDataSeries[0]) }">
                    <dxo-title text="Time (s)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxo-argument-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('velocityX')"  type="continuous" name="vel_x_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Velocity X (m/s)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('velocityZ')"  type="continuous" name="vel_z_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Velocity Y (m/s)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="isSeriesSelected('height')"  type="continuous" name="pos_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Height (m)">
                        <dxo-font size="24" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
            </dx-chart>
        </div>
    }
   
</div>




<dx-popup
    [visible]="mobileChartSelection !== null"
    [showTitle]="true"
    [title]="getChartPopupTitle()"
     width="100%"
     height="100%"
     maxWidth="100%"
     maxHeight="100%"
    [dragEnabled]="false"
    [showCloseButton]="true"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    (onHiding)="mobileChartSelection = null"
    (onShowing)="onPopupShowing()"
    (onShown)="onPopupShown()"
    >
    @if(screenservice.isLandscape){
    <div style="height:100%;width:100%;display:flex;flex-direction:column;" [attr.data-chart-key]="chartKey">
        <dx-chart
                [dataSource]="getFilteredData()"
                style="flex:1 1 auto;min-height:0;width:100%;"
            >
            <dxo-zoom-and-pan
                argumentAxis="both"
                valueAxis="none"> <!-- or "zoom" | "pan" | "none" -->
            </dxo-zoom-and-pan>
            <dxo-tooltip
                    [enabled]="true"
                    [customizeTooltip]="customizeTooltip"
                        [zIndex]="10000"
            ></dxo-tooltip>
            <dxo-margin
                [left]="80">
            </dxo-margin>
                <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
                <dxo-legend [visible]="false"></dxo-legend>
                <dxo-common-series-settings
                    #seriesSettings
                    argumentField="time_s"
                    type="spline"
                >
                    <dxo-point [visible]="false"></dxo-point>
                </dxo-common-series-settings>
                <dxo-common-axis-settings [valueMarginsEnabled]="true">
                    <!-- <dxo-label>
                        <dxo-font size="18"></dxo-font>
                    </dxo-label> -->
                </dxo-common-axis-settings>
                <dxi-series *ngIf="mobileChartSelection == 'velocityX'" color="#424242" valueField="velocityX" axis="vel_x_axis"></dxi-series>
                <dxi-series *ngIf="mobileChartSelection == 'velocityZ'" color="#424242" valueField="velocityZ" axis="vel_z_axis"></dxi-series>
                <dxi-series *ngIf="mobileChartSelection == 'height'" color="#424242" valueField="hgt_m" axis="pos_axis"></dxi-series>
                <dxo-argument-axis [wholeRange]="{ endValue: getAxisMaxTime(mobileChartSelection) }">
                    <dxo-title text="Time (s)">
                        <!-- <dxo-font size="24" weight="bold"></dxo-font> -->
                    </dxo-title>
                </dxo-argument-axis>
                <dxi-value-axis *ngIf="mobileChartSelection == 'velocityX'"  type="continuous" name="vel_x_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Velocity X (m/s)">
                        <dxo-font size="16" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="mobileChartSelection == 'velocityZ'"  type="continuous" name="vel_z_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Velocity Y (m/s)">
                        <dxo-font size="16" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
                <dxi-value-axis *ngIf="mobileChartSelection == 'height'"  type="continuous" name="pos_axis" [valueMarginsEnabled]="true" [minValueMargin]="0.1" [maxValueMargin]="0.1">
                    <dxo-title text="Height (m)">
                        <dxo-font size="16" weight="bold"></dxo-font>
                    </dxo-title>
                </dxi-value-axis>
            </dx-chart>
    </div>
    }
    @else {
        <div style="display: flex; align-items: flex-start; justify-content: center; padding-top: 20px; height: 100%; text-align: center;">
            <span>Device must be in Landscape to view graphs.</span>
        </div>
    }

</dx-popup>